// extracted by mini-css-extract-plugin
module.exports = {"icomoon-font":"BasePrice_icomoon-font__VdCs4","BasePriceHolder":"BasePrice_BasePriceHolder__3NMGA","NoWrapped":"BasePrice_NoWrapped__1RJKe"};